function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.956 1.565v20.87a1.565 1.565 0 11-3.13 0V1.565a1.565 1.565 0 113.13 0zM3.13 14.609v7.304a1.565 1.565 0 11-3.13 0v-7.304a1.565 1.565 0 113.13 0zm15.131-4.696v12.522a1.566 1.566 0 01-3.131 0V9.913a1.565 1.565 0 113.131 0z",
  fill: "#fff",
  fillRule: "evenodd"
});

var SvgStatistics = function SvgStatistics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18.261,
    height: 24,
    viewBox: "0 0 18.261 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStatistics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/statistics.89f4af6e.svg";
export { ForwardRef as ReactComponent };